module.exports = __webpack_public_path__ + "img/logo.3cf93219.png";